<script setup></script>

<template>
    <Link :href="'/'">
        <img
            class="size-16 object-contain"
            src="/src/logo/logo-darkmode.png"
            alt="priznani-snadno.cz"
        />
    </Link>
</template>
